import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import { TripGroupingCreatePage } from './create-trip-grouping'
import { TripGroupingListPage } from './trip-grouping-list'
import { TripGroupingUpdatePage } from './update-trip-grouping'

const tripGroupingRoutes: Route[] = [
  {
    path: Paths.TRIP_GROUPING_LIST_PAGE,
    element: <TripGroupingListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_GROUPING_CREATE_PAGE,
    element: <TripGroupingCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_GROUPING_UPDATE_PAGE,
    element: <TripGroupingUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default tripGroupingRoutes
